import * as React from 'react';

export const useInterval = (handle: () => void, time: number) => {
  const intervalRef = React.useRef<NodeJS.Timeout>();
  React.useEffect(() => {
    handle();
  }, []);
  React.useEffect(() => {
    resetInterval();
    return () => {
      clearInterval(intervalRef.current as NodeJS.Timeout)
    }
  }, []);
  const resetInterval = () => {
    intervalRef.current = setInterval(handle, time);
  }
  return {
    reset: () => resetInterval(),
    clear: () => clearInterval(intervalRef.current as NodeJS.Timeout)
  }
}